export interface RuntimeConfig {
  readonly stage: 'sandbox' | 'production';
  readonly apiBaseUrl: string;
  readonly cognitoUserPoolId: string;
  readonly cognitoClientId: string;
  readonly region: string;
}

declare global {
  interface Window {
    __CRIME_RUNTIME_CONFIG__?: Partial<RuntimeConfig>;
  }
}

function readOptionalString(value: string | undefined): string | undefined {
  if (value === undefined) {
    return undefined;
  }
  const trimmed = value.trim();
  return trimmed.length > 0 ? trimmed : undefined;
}

function readStage(stage?: string): RuntimeConfig['stage'] {
  return stage === 'production' ? 'production' : 'sandbox';
}

export function getRuntimeConfig(): RuntimeConfig {
  const runtime = window.__CRIME_RUNTIME_CONFIG__ ?? {};
  const runtimeApiBaseUrl = readOptionalString(runtime.apiBaseUrl);
  const runtimeUserPoolId = readOptionalString(runtime.cognitoUserPoolId);
  const runtimeClientId = readOptionalString(runtime.cognitoClientId);
  const runtimeRegion = readOptionalString(runtime.region);

  return {
    stage: readStage(runtime.stage ?? process.env.REACT_APP_STAGE),
    apiBaseUrl: runtimeApiBaseUrl ?? readOptionalString(process.env.REACT_APP_API_BASE_URL) ?? '',
    cognitoUserPoolId: runtimeUserPoolId ?? readOptionalString(process.env.REACT_APP_COGNITO_USER_POOL_ID) ?? '',
    cognitoClientId: runtimeClientId ?? readOptionalString(process.env.REACT_APP_COGNITO_CLIENT_ID) ?? '',
    region: runtimeRegion ?? readOptionalString(process.env.REACT_APP_AWS_REGION) ?? 'eu-north-1',
  };
}
